<template>
  <div class="route-search">
    <TitleFrame text="ルート検索">
      <template slot="contents">
        <RouteSearchInputs @click-button="onClickSearch" />
        <div class="map-area">
          <GoogleMapOnlyCurrent/>
        </div>
        <p class="text-red text-center">「利用中の運転は禁止（閲覧不可）」</p>
        <TextLink text="事後アンケートに回答" @click-text="onCkickAnswers" />
        <IsTest />
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import TextLink from '@/components/Atoms/TextLink'
import RouteSearchInputs from '@/components/Organisms/RouteSearchInputs'
import GoogleMapOnlyCurrent from '@/components/Organisms/GoogleMapOnlyCurrent'
import IsTest from '@/components/Organisms/isTest'
import Firebase from './../../firebase'

export default {
  name: 'route-search',
  components: {
    TitleFrame,
    RouteSearchInputs,
    GoogleMapOnlyCurrent,
    IsTest,
    TextLink
  },
  computed: {
    ...mapState([
      'currentLat',
      'currentLng',
      'DepLatLng',
      'DesLatLng',
      'isAgreed',
      'isAnswered',
      'uid'
    ]),
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  methods: {
    ...mapMutations([
      'changeSearch',
      'loadingStart',
      'loadingEnd',
      'changeCurrentLatLng',
      'loadingStartMini',
      'loadingEndMini',
      'setDepLatLng',
      'setDesLatLng',
      'changeUid'
    ]),
    onCkickAnswers (e) {
      this.$router.push({name: 'Answers'})
    },
    onClickSearch (e) {
      var deplist = JSON.parse(this.$cookies.get('departurelist'))
      if (deplist) {
        if (!deplist.filter(x => x === e.departure).length) {
          deplist.unshift(e.departure)
          this.$cookies.set('departurelist', JSON.stringify(deplist))
        }
      } else {
        this.$cookies.set('departurelist', JSON.stringify([e.departure]))
      }

      var deslist = JSON.parse(this.$cookies.get('destionationlist'))
      if (deslist) {
        if (!deslist.filter(x => x === e.destination).length) {
          deslist.unshift(e.destination)
          this.$cookies.set('destionationlist', JSON.stringify(deslist))
        }
      } else {
        this.$cookies.set('destionationlist', JSON.stringify([e.destination]))
      }

      this.changeSearch(e)
    },
    putLog () {
      navigator.geolocation.getCurrentPosition(function (position) {
        Firebase.putLog({
          ActionType: 'SearchRoute',
          CurrentLatLon: {
            current_lat: position.coords.latitude,
            current_lon: position.coords.longitude
          }
        })
      },
      function (err) {
        var msgs = [
          err.message,
          '位置情報の取得を許可されていません。',
          '位置情報の取得に失敗しました。',
          '位置情報を取得中にタイムアウトしました。'
        ]
        window.alert(msgs[err.code])
      },
      { maximumAge: 0 })
    }
  },
  watch: {
    currentLng: {
      immideate: true,
      handler: function () {
        this.loadingEnd()
        this.loadingEndMini()
        Firebase.putLocation()
      }
    },
    DepLatLng: {
      immideate: true,
      handler: function () {
        if (this.DepLatLng && this.DesLatLng) {
          this.putLog()
          this.$router.push({name: 'DropSpotSelect'})
        }
      }
    },
    DesLatLng: {
      immideate: true,
      handler: function () {
        if (this.DepLatLng && this.DesLatLng) {
          this.putLog()
          this.$router.push({name: 'DropSpotSelect'})
        }
      }
    }
  },
  mounted () {
    this.loadingStart()
    this.changeSearch(undefined)
    this.setDepLatLng(undefined)
    this.setDesLatLng(undefined)

    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAnswered) {
      this.$router.push({name: 'Consent'})
    }
    if (this.currentLat && this.currentLng) {
      this.loadingEnd()
      this.loadingEndMini()
      Firebase.putLocation()
    } else {
      this.loadingEnd()
      this.loadingStartMini()
      let changeCurrentLatLng = this.changeCurrentLatLng
      navigator.geolocation.getCurrentPosition(function (position) {
        changeCurrentLatLng({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        })
      },
      function (err) {
        var msgs = [
          err.message,
          '位置情報の取得を許可されていません。',
          '位置情報の取得に失敗しました。',
          '位置情報を取得中にタイムアウトしました。'
        ]
        window.alert(msgs[err.code])
      },
      { maximumAge: 0 })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.route-search{
  height: 100%;
}
.map-area{
  height: calc(100% - 19rem);
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/RouteSearch.vue